import { computed, Ref } from "vue";

import { injectBetData } from "../lib/provideInjectors";

export function useHasEvents(eventsLoading: Ref<boolean>) {
  const betData = injectBetData();

  const events = computed(() => betData?.value?.events);

  const hasEvents = computed(() => {
    if (eventsLoading.value) return;

    if (Object.keys(events?.value).length === 0) {
      window.parent.postMessage({ type: "f8_no_events" }, "*");
      return false;
    }

    return true;
  });

  return { hasEvents };
}
